import type { SubLinhaApontamento } from '../types';

/**
 * Como cada sublinha da grade de apontamento se chama na tela.
 *
 * Nasceu dentro de `ApontamentoGridPage.tsx` e saiu de lá quando a tela de
 * Tratativas SME ↔ DRE passou a precisar do mesmo rótulo: duas repetições já
 * pedem extração (CLAUDE.md, "Regras de interface", item 1).
 *
 * Os textos são os do protótipo, abreviados porque nasceram como cabeçalho da
 * coluna fixa da grade diária — onde o espaço é de uma coluna estreita e o
 * significado completo vive no tooltip.
 */
export const SUBLINHA_LABEL: Record<SubLinhaApontamento, string> = {
  NCAD: 'Não cad.',
  CAD: 'Cadeir.',
  NC_CONT: 'Cont. NC',
  CAD_CONT: 'Cont. Cad',
  NC_COMP: 'Compl. NC',
  CAD_COMP: 'Compl. Cad',
  FALTAS: 'Faltas alunos',
  FALTA_VEICULO: 'Falta veículo',
};

/**
 * O rótulo de uma sublinha que chegou como texto solto.
 *
 * A tratativa guarda a sublinha como `text` no banco (a coluna é do tipo
 * enumerado, mas a função de leitura devolve `text`), então quem lê de lá não
 * tem o tipo estreito em mãos. Valor desconhecido volta como veio: mostrar o
 * código cru é melhor que mostrar vazio.
 */
export function rotuloDeSublinha(sublinha: string): string {
  return SUBLINHA_LABEL[sublinha as SubLinhaApontamento] ?? sublinha;
}
